import { translate } from "@jsverse/transloco";

export function sanitizeToDate(inputdate: any) {
    const date = new Date(inputdate);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
}

export function sanitizeToDateTime(utcDateString: string) {
    // Parse the input date string
    const date = new Date(utcDateString);
    
    // Extract the time zone offset from the input date string
    const offsetMatch = utcDateString.match(/([+-]\d{2}):(\d{2})$/);
    
    // If the offset is not found, default to no offset
    const offsetHours = offsetMatch ? parseInt(offsetMatch[1], 10) : 0;
    const offsetMinutes = offsetMatch ? parseInt(offsetMatch[2], 10) : 0;
    
    // Calculate the offset in milliseconds
    const offsetInMillis = (offsetHours * 60 + offsetMinutes) * 60 * 1000;
    
    // Adjust the date to local time by subtracting the offset
    const localDate = new Date(date.getTime() + offsetInMillis);
    
    // Format the date and time
    const day = String(localDate.getDate()).padStart(2, '0');
    const month = String(localDate.getMonth() + 1).padStart(2, '0');
    const year = localDate.getFullYear();

    const hours = String(localDate.getHours()).padStart(2, '0');
    const minutes = String(localDate.getMinutes()).padStart(2, '0');
    
    return `${day}.${month}.${year} | ${hours}:${minutes}`;
}

/**
 * First moment of the given day in the browser's local time zone, as UTC instant (ISO string) for the backend.
 * Respects daylight saving time, unlike a conversion with a fixed "+01:00" offset which shifts the
 * day window by one hour in summer.
 */
export function startOfLocalDay(date: Date | string): string {
    const day = new Date(date);
    day.setHours(0, 0, 0, 0);
    return day.toISOString();
}

/** Last moment of the given day in the browser's local time zone, as UTC instant (ISO string). See startOfLocalDay. */
export function endOfLocalDay(date: Date | string): string {
    const day = new Date(date);
    day.setHours(23, 59, 59, 999);
    return day.toISOString();
}
